// import Avionicsgen1Mob from "../../../../../assets/image/Domains/avionics_stack_gen_1_2.0_mob.webp"
// import Avionicsgen2Mob from "../../../../../assets/image/Domains/avionics_stack_gen_2_2.0_mob.webp"
// import UHFforSpaceMob from "../../../../../assets/image/Domains/uhf_for_space_2.0_mob.webp"


import Configuration from "../../../../../config/configuration"

const AntarisLogo = `${Configuration.S3_URL}Domains/Space/antaris-logo.webp`
const SatosLogo = `${Configuration.S3_URL}Domains/Space/satos-logo.webp`
const Avionicsgen1 = `${Configuration.S3_URL}Domains/Space/avionics_stack_gen_1_2.0.webp`
const Avionicsgen1Mob = `${Configuration.S3_URL}Domains/Space/avionics_stack_gen_1_2.0_mob.webp`
const Avionicsgen2 = `${Configuration.S3_URL}Domains/Space/avionics_stack_gen_2_2.0.webp`
const Avionicsgen2Mob = `${Configuration.S3_URL}Domains/Space/avionics_stack_gen_2_2.0_mob.webp`
const UHFforSpace = `${Configuration.S3_URL}Domains/Space/uhf_for_space_2.0.webp`
const UHFforSpaceMob = `${Configuration.S3_URL}Domains/Space/uhf_for_space_2.0_mob.webp`


export const SpaceDomain = {
    heading: <>EXPLORE THE FUTURE OF <br /> <span style={{ color: "var(--primary-color)" }}>SPACE TECHNOLOGY</span></>,
    subHeading: "Discover cutting-edge space products designed for innovation, performance, and reliability beyond Earth. From advanced systems to groundbreaking solutions, we bring the universe closer to you.",
    buttonText: "Explore More"
}

export const AvionicsStackGen1 = {
    product1: "AVIONICS STACK GEN 1",
    // points: [
    //     "Distributed architecture with advanced edge processing",
    //     "High-speed networking and large on-board storage",
    //     "Health monitoring, fail-safes, and auto-recovery",
    //     "Health monitoring, fail-safes, and auto-recovery"
    // ],
    image: Avionicsgen1,
    mobileimage: Avionicsgen1Mob,
    navigation: [
        {
            // description: <>SEAMLESSLY INTEGRATED WITH<br /> the <span style={{ color: 'var(--primary-color)' }}>SATOS AVIONCIS STACK</span></>,
            description: "Powered by Antaris SatOs",
            link: "https://www.antaris.space/satos",
            image: SatosLogo
        },
        {
            // description: <>OUR VALUED PARTNERS <br /><span style={{ color: 'var(--primary-color)' }}> AND CUSTOMERS</span></>,
            description: "Our Valued Partners And Customers",
            link: "https://www.antaris.space/",
            image: AntarisLogo
        }
    ]

}


export const AvionicsStackGen2 = {
    product1: "AVIONICS STACK GEN 2",
    image: Avionicsgen2,
    mobileimage: Avionicsgen2Mob,
    points: [
        "Software-defined fail-safes, redundancy, and automated health monitoring",
        "Distributed OBCs with edge GPU, GPS, and up to 8TB SSD storage",
        "Software-controlled networking with flexible I/O",
        "Modular design for easy mission expansion"
    ],
    navigation: [
        {
            description: <>SEAMLESSLY INTEGRATED WITH<br /> the <span style={{ color: 'var(--primary-color)' }}>SATOS AVIONCIS STACK</span></>,
            link: "https://www.antaris.space/satos",
            image: SatosLogo
        },
        {
            description: <>OUR VALUED PARTNERS <br /><span style={{ color: 'var(--primary-color)' }}> AND CUSTOMERS</span></>,
            link: "https://www.antaris.space/",
            image: AntarisLogo
        }


    ]
}


export const UhfSpace = {
    product1: "UHF FOR SPACE",
    mobileimage: UHFforSpaceMob,
    points: [
        "Software-defined fail-safes, redundancy, and automated health monitoring",
        "Distributed OBCs with edge GPU, GPS, and up to 8TB SSD storage",
        "Software-controlled networking with flexible I/O",
        "Modular design for easy mission expansion"
    ],
    image: UHFforSpace,
    navigation: [
        {
            // description: <>SEAMLESSLY INTEGRATED WITH<br /> the <span style={{ color: 'var(--primary-color)' }}>SATOS AVIONCIS STACK</span></>,
            description: "Seamlessly integrated with the Antaris SatOS",
            link: "https://www.antaris.space/satos",
            image: SatosLogo
        },
        // {
        //     description: <>OUR VALUED PARTNERS <br /><span style={{ color: 'var(--primary-color)' }}> AND CUSTOMERS</span></>,
        //     link: "https://www.antaris.space/",
        //     image: AntarisLogo
        // }
    ]

}